import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RenaultUserAdminDTO, RenaultUserAnimationDataDTO, RenaultUserDTO, RenaultUserAdminPostDTO, RenaultUserProfileDTO, RenaultUserProfilePostDTO, RenaultUserProfileDistributorDTO } from '../models/renault-user-dto';
import { DataTablesResponse } from '../models/datatables';
import { RenaultUserPositionDataTableDTO } from '../models/renault-animation-user-position-dto';
import { RenaultDistributorDataModel } from '../models/renault-distributor';
import { RenaultUserMyServiceDataDTO } from '../models/renault-myservice-dto';

@Injectable({
  providedIn: 'root'
})

export class UserService {

  private pathAPI = environment.urlAPI;
  private controller = "RenaultUser/";

  public userData = new BehaviorSubject<RenaultUserDTO>(null);
  public appConditionsApproved = new BehaviorSubject<boolean>(null);
  public userDistributorData = new BehaviorSubject<RenaultDistributorDataModel[]>([]);

  constructor(private http: HttpClient) {
    this.initializeUserData();
  }

  public get(id: string): Observable<RenaultUserDTO> {
    return this.http.get<RenaultUserDTO>(this.pathAPI + this.controller + id);
  }

  public getUserInfo(): Observable<RenaultUserDTO> {
    return this.http.get<RenaultUserDTO>(this.pathAPI + this.controller + 'GetLoggedUserInfo');
  }

  public getUserDistributorsBBDD(): Observable<RenaultDistributorDataModel[]> {
    return this.http.get<RenaultDistributorDataModel[]>(this.pathAPI + this.controller + 'GetLoggedUserDistributors');
  }

  // public getUserDistributors(): Observable<RenaultDistributorDataModel[]> {
  //   return this.http.get<RenaultDistributorDataModel[]>(this.pathAPI + this.controller + 'GetLoggedUserDistributors');
  // }

  public getLoggedUserForAnimation(idAction: string): Observable<RenaultUserAnimationDataDTO> {
    return this.http.get<RenaultUserAnimationDataDTO>(this.pathAPI + this.controller + 'GetLoggedUserForAnimation/' + idAction);
  }

  public getLoggedUserForMyService(idAction): Observable<RenaultUserMyServiceDataDTO> {
    return this.http.get<RenaultUserMyServiceDataDTO>(this.pathAPI + this.controller + 'GetLoggedUserForMyService/' + idAction);
  }

  public getLoggedUserFilters(): Observable<number[]> {
    return this.http.get<number[]>(this.pathAPI + this.controller + 'GetLoggedUserFilters');
  }

  public updateUserActiveDistributor(id: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + "UpdateUserActiveDistributor/" + id, null);
  }

  public putFromAnimation(id: string, data: RenaultUserAnimationDataDTO): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + "PutFromAnimation/" + id, data);
  }

  setUserData(user: RenaultUserDTO) {
    this.userData.next(user);
  }

  setUserAppConditions(approved: boolean) {
    this.appConditionsApproved.next(approved);
  }

  setUserDistributor(data: RenaultDistributorDataModel[]) {
    this.userDistributorData.next(data);
  }

  getUserData(): Observable<RenaultUserDTO> {
    return this.userData.asObservable();
  }

  getAppConditions(): Observable<boolean> {
    return this.appConditionsApproved.asObservable();
  }

  getUserDistributors(): Observable<RenaultDistributorDataModel[]> {
    return this.userDistributorData.asObservable();
  }

  public initializeUserData() {
    const that = this;
    this.getUserInfo().subscribe(resp => {
      that.setUserData(resp);
    });
    this.CheckConditionsDistributor().subscribe(resp => {
      that.setUserAppConditions(resp);
    });
    this.getUserDistributorsBBDD().subscribe(resp => {
      that.setUserDistributor(resp);
    });
  }

  public getDataTableUserByPvGroup(data: any, idPvGroup: number): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableUserByPvGroup/' + idPvGroup, data);
  }

  public getDataTableUsersPosition(idPvGroup: number): Observable<RenaultUserPositionDataTableDTO[]> {
    return this.http.get<RenaultUserPositionDataTableDTO[]>(this.pathAPI + this.controller + 'GetDataTableUsersPosition/' + idPvGroup);
  }

  //#region  ADMIN

  public getAdmin(id: string): Observable<RenaultUserAdminDTO> {
    return this.http.get<RenaultUserAdminDTO>(this.pathAPI + this.controller + "GetAdmin/" + id);
  }

  public postAdmin(data: RenaultUserAdminPostDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + "PostAdmin/", data);
  }

  public putAdmin(id: string, data: RenaultUserAdminPostDTO): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + "PutAdmin/" + id, data);
  }

  public getDataTableAdmin(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableAdmin', data);
  }

  //#endregion

  //#region  PROFILE

  public getProfile(id: string): Observable<RenaultUserProfileDTO> {
    return this.http.get<RenaultUserProfileDTO>(this.pathAPI + this.controller + "GetProfile/" + id);
  }

  public putProfile(id: string, data: RenaultUserProfilePostDTO): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + "PutProfile/" + id, data);
  }


  public GetUserProfileDistributor(id: string): Observable<RenaultUserProfileDistributorDTO> {
    return this.http.get<RenaultUserProfileDistributorDTO>(this.pathAPI + this.controller + "GetUserProfileDistributor/" + id);
  }


  //#endregion

  //#region CONDICIONES

  public CheckConditionsDistributor(): Observable<boolean> {
    return this.http.get<boolean>(this.pathAPI + this.controller + 'CheckConditionsDistributor');
  }

  public SetConditionsDistributor(): Observable<boolean> {
    return this.http.get<boolean>(this.pathAPI + this.controller + 'SetConditionsDistributor');
  }

  //#endregion

  //#region COMPROBAR SI EL USUARIO ES R1
  public CheckUserDistributorR1(): Observable<boolean> {
    return this.http.get<boolean>(this.pathAPI + this.controller + 'CheckUserDistributorR1');
  }
  //#endregion

  //#region COMPROBAR SI EL USUARIO ES R2 Y SI TIENE EL CONTRATO FIRMADO
  public CheckUserDistributorR2Ok(): Observable<boolean> {
    return this.http.get<boolean>(this.pathAPI + this.controller + 'CheckUserDistributorR2Ok');
  }
  //#endregion

  //#region USUARIOS ANONIMIZADOS EN ANIMACIÓN
  public isLoggedUserAnonimizedAnimationUser(): Observable<boolean> {
    return this.http.get<boolean>(this.pathAPI + this.controller + 'IsLoggedUserAnonimizedAnimationUser');
  }
  //#endregion

  downloadUserInfo(): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetExcelUserInfo';
    return this.http.post<Blob>(endpoint, null, requestOptions);
  }

}
